<template>
	<q-dialog v-model="myreadmoremodal" transition-show="fade" transition-hide="fade">
		<div class="hris-modal hris-modal-lg">
			<div class="hris-modal-header">
				<div>
					<h2 class="hris-modal-title caps" v-html="subject"></h2>
					<p class="hris-modal-subtitle" v-html="timeAgo"></p>
				</div>
				<q-btn flat dense round v-close-popup aria-label="Close">
					<i class="fas fa-times"></i>
				</q-btn>
			</div>
			<div class="hris-modal-body" style="max-height: 55vh; overflow-y: auto;">
				<p v-html="fullMsg"></p>
			</div>
			<div class="hris-modal-footer">
				<q-btn unelevated class="hris-q-primary" label="Close" v-close-popup></q-btn>
			</div>
		</div>
	</q-dialog>
</template>

<script>
	import axios from 'axios';
	import mixins from '../../mixins';
	export default {
	  	data () {
	    return {
	      myreadmoremodal: false,
	      date: null,
	      subject: '',
	      message: '',
	      fullMsg: '',
	      timeAgo: ''
	    }
 	},

    created() {
    	this.eventHub.$on('openReadMoreModal', this.openReadMoreModal);
    },

    methods: {
    	openReadMoreModal:function(props){
    		this.myreadmoremodal = props.stat;
    		this.id = props.obj.id;
    		this.subject = props.obj.subject;
    		this.message = props.obj.message;
    		this.fullMsg = props.obj.full_message;
    		this.attachment = props.obj.attachment;
    		this.dateCreated = props.obj.date_created;
    		this.created_by = props.obj.created_by;
    		this.is_publish = props.obj.is_publish;
    		this.is_deleted = props.obj.is_deleted;
    		this.timeAgo = '<small>' + props.obj.timeAgo + '</small>';
    		console.log(props.obj)
		},
    }
 
}
</script>
